import { Controller } from "@hotwired/stimulus"

// navigator.clipboard exists only on HTTPS/localhost; on plain HTTP fall back to execCommand.
export default class extends Controller {
  static targets = ["source", "button"]
  static values = { text: String }

  async copy(event) {
    event.preventDefault()
    const text = this.hasTextValue ? this.textValue : this.sourceTarget.value.trim()
    const ok = await this.write(text)
    if (!ok && this.hasSourceTarget) this.sourceTarget.select()
    this.feedback(ok)
  }

  async write(text) {
    if (window.isSecureContext && navigator.clipboard?.writeText) {
      try { await navigator.clipboard.writeText(text); return true } catch (_) { /* fall through */ }
    }
    const area = document.createElement("textarea")
    area.value = text
    area.setAttribute("readonly", "")
    Object.assign(area.style, { position: "fixed", top: "-1000px", opacity: "0" })
    // Inside a modal/offcanvas the focus trap would steal focus from a textarea appended to body.
    const host = this.element.closest(".modal, .offcanvas") || document.body
    host.appendChild(area)
    area.select()
    area.setSelectionRange(0, text.length)
    let ok = false
    try { ok = document.execCommand("copy") } catch (_) { ok = false }
    area.remove()
    return ok
  }

  feedback(ok) {
    const button = this.hasButtonTarget ? this.buttonTarget : this.element
    // Remember the markup once: a repeated click while feedback is shown must not capture the feedback as "original".
    this.originalHtml ??= button.innerHTML
    clearTimeout(this.timer)
    button.innerHTML = ok ? '<i class="bi bi-check2"></i> Скопировано' : "Нажмите Ctrl+C"
    this.timer = setTimeout(() => {
      button.innerHTML = this.originalHtml
      this.originalHtml = null
    }, 2000)
  }
}
